import { getPendingSyncOperations, clearSyncQueue } from './offlineStorage';
import {
  createTransaction, updateTransaction, deleteTransaction,
  createBill, updateBill, deleteBill,
  createInvestment, updateInvestment, deleteInvestment
} from '../services/supabaseService';
import toast from 'react-hot-toast';

export const syncOfflineData = async (userId) => {
  if (!navigator.onLine) {
    console.log('Cannot sync: offline');
    return { success: false, message: 'No internet connection' };
  }

  try {
    const pendingOperations = await getPendingSyncOperations();
    
    if (pendingOperations?.length === 0) {
      return { success: true, message: 'No pending operations' };
    }

    console.log(`Syncing ${pendingOperations?.length} pending operations...`);
    let successCount = 0;
    let failCount = 0;

    for (const operation of pendingOperations) {
      try {
        const { table, operation: op, data } = operation;

        if (table === 'transactions') {
          if (op === 'create') await createTransaction(userId, data);
          else if (op === 'update') await updateTransaction(data?.id, data);
          else if (op === 'delete') await deleteTransaction(data?.id);
        } else if (table === 'bills') {
          if (op === 'create') await createBill(userId, data);
          else if (op === 'update') await updateBill(data?.id, data);
          else if (op === 'delete') await deleteBill(data?.id);
        } else if (table === 'investments') {
          if (op === 'create') await createInvestment(userId, data);
          else if (op === 'update') await updateInvestment(data?.id, data);
          else if (op === 'delete') await deleteInvestment(data?.id);
        }

        successCount++;
      } catch (error) {
        console.error('Sync operation failed:', error);
        failCount++;
      }
    }

    if (failCount === 0) {
      await clearSyncQueue();
      toast?.success(`Synced ${successCount} offline operations successfully`);
      return { success: true, message: `Synced ${successCount} operations` };
    } else {
      toast?.error(`Synced ${successCount} operations, ${failCount} failed`);
      return { success: false, message: `${failCount} operations failed` };
    }
  } catch (error) {
    console.error('Offline sync error:', error);
    toast?.error('Sync failed. Will retry later.');
    return { success: false, message: error?.message };
  }
};

// Auto-sync when connection is restored
window.addEventListener('online', () => {
  console.log('Connection restored, triggering sync...');
  toast?.success('Back online! Syncing data...');
});

window.addEventListener('offline', () => {
  console.log('Connection lost');
  toast(
    <div role="alert" aria-live="assertive">
      <p className="text-sm font-semibold">You are offline</p>
      <p className="text-xs mt-0.5">Changes will sync when connection is restored</p>
    </div>,
    {
      duration: 5000,
      position: 'top-right',
      icon: '📶',
      style: {
        background: '#fef3c7',
        border: '1px solid #fde68a',
        color: '#92400e',
        padding: '16px',
        borderRadius: '8px'
      }
    }
  );
});